<template>
    <!-- 选择角色 -->
  <Row>
    <Col span="24">
      <Col span="12" v-for="(item, index) in charaLootsList" :key="index">
        <Card >
          <p slot="title" style="height: 24px">{{ item.name }} <Button   size="small" @click="enroll(item.userId)">选择</Button></p>
          <p slot="title" style="height: 24px">{{ item.name }} <Button   size="small" @click="enroll2(item.userId)">移动端(测试中)</Button></p>
          <p>{{ item.level }}</p>
        </Card>
      </Col>
    </Col>
    <Button   size="small" @click="createName()">创建角色</Button>
    <!-- 创建角色 -->
    <Modal width="620" title="创建角色" v-model="pasEject" @on-ok="reg()" :styles="{ top: '100px' }">
      <Form :model="formRegister" :label-width="68">
        <FormItem label="昵称">
          <Input placeholder="请输入 6~20 位的帐号" v-model="formRegister.name" />
        </FormItem>
        <FormItem label="灵根">
          <Select v-model="formRegister.spiritRoot" >
            <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>

<!--      <div class="parent">
             <div class="div1">武器</div>
              <div class="div2">玄端</div>
              <div class="div3">头冠</div>
              <div class="div4">项链</div>
              <div class="div5">法宝</div>
              <div class="div6">绶佩</div>
              <div class="div7">绶带</div>
              <div class="div8">鞜履</div>
              <div class="div9">戒指</div>
              <div class="div10"> </div>
              <div class="div11"> <img  src="@/assets/dazou.png" alt="等待图片加载ing"  /> </div>
            </div>-->
          </Row>
        </template>
        <script>
        export default {
            name: "selectChara",
            data() {
                return {
                   charaLootsList: [],
                   user: {}, // 用户的全部消息
                   pasEject:false,
                    formRegister: {
                      name: undefined,
                      spiritRoot: undefined,
                      userId: undefined,
                    },
                  cityList: [
                    {
                      value: '1',
                      label: '金灵根'
                    },
                    {
                      value: '2',
                      label: '木灵根'
                    },
                    {
                      value: '3',
                      label: '水灵根'
                    },
                    {
                      value: '4',
                      label: '火灵根'
                    },
                    {
                      value: '5',
                      label: '土灵根'
                    },
                    {
                      value: '6',
                      label: '风灵根'
                    },
                    {
                      value: '7',
                      label: '雷灵根'
                    },
                    {
                      value: '8',
                      label: '冰灵根'
                    }
                  ],
                };
            },
            created() {
                if(this.charaLootsList.length<1){
                  this.selectCharaList();
                }
            },
            mounted() {
                /*this.$http
                    .get("/gameChara/mapDropItems")
                    .then((res) => {
                        this.mapLootsList = res.data.data;
                    })
                    .catch((err) => {
                        this.$Notice.warning("获取地图掉落失败");
                    });*/
            },
            methods: {
                distinguishColor(color) {
                    if (color == 1) {
                        return "#000";
                    } else if (color == 2) {
                        return "#c5c52f";
                    } else if (color == 3) {
                        return "#049c04";
                    } else if (color == 4) {
                        return "#005aff";
                    } else if (color == 5) {
                        return "#ff00e0";
                    } else if (color == 6) {
                        return "#ff0000";
                    } else if (color == 7) {
                        return "#ff8c00";
                    } else {
                        return "#ff00c3e0";
                    }
                },
                selectCharaList(){
                  this.$http.post("gamepassport/queryCharaList", this.formlogin,{
                    headers:{
                      'Authorization': this.getCookie("token")
                    }
                  }).then((res) => {
                      this.charaLootsList=res.data.data;
                    }
                  );
                },
                enroll(id){
                  this.setCookie("charaId", id, 3);
                  //console.log(res.data.data);
                  localStorage.setItem("charaId", id);
                  document.cookie =  document.cookie + ";charaId=" + id + ";expires=" + new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30).toUTCString() + ";path=/;"
                  this.addAccount(localStorage.getItem("username"), id)
                  //返回角色列表 进行使用或创建操作
                  this.$router.push({ name: "index" });

                  this.$router.go(0);
                },
                enroll2(id){
                  this.setCookie("charaId", id, 3);
                  //console.log(res.data.data);
                  localStorage.setItem("charaId", id);
                  document.cookie =  document.cookie + ";charaId=" + id + ";expires=" + new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30).toUTCString() + ";path=/;"
                  this.addAccount(localStorage.getItem("username"), id)
                  //返回角色列表 进行使用或创建操作
                  this.$router.push({ name: "indexMobile" });
                  this.$router.go(0);
                },
                addAccount(username, charaId) {
                  let accounts = localStorage.getItem('accounts')
                  if (accounts == null) {
                    accounts = '{}'
                  }
                  let accountObj = JSON.parse(accounts)
                  accountObj[charaId] = {
                    username,
                    charaId
                  }
                  localStorage.setItem('accounts', JSON.stringify(accountObj))
                },
                createName(){
                    this.pasEject=true;
                    this.user = JSON.parse(sessionStorage.getItem("user"));
                    this.formRegister.userId=this.user.userId;
                },
                reg(){
                  this.$http.post("gamepassport/createChara", this.formRegister).then((res) => {
                    this.selectCharaList();
                    if (res.data.msg != "ok") {
                      this.$Notice.warning({title:res.data.msg});
                      return;
                    }
                  });
                },
            },
        };
        </script>

        <style scoped>
        .parent {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          grid-template-rows: repeat(5, 1fr);
          grid-column-gap: 0px;
          grid-row-gap: 0px;
        }

        .div1 { grid-area: 1 / 1 / 2 / 2; }
        .div2 { grid-area: 2 / 1 / 3 / 2; }
        .div3 { grid-area: 3 / 1 / 4 / 2; }
        .div4 { grid-area: 4 / 1 / 5 / 2; }
        .div5 { grid-area: 5 / 2 / 6 / 3; }
        .div6 { grid-area: 1 / 4 / 2 / 5; }
        .div7 { grid-area: 2 / 4 / 3 / 5; }
        .div8 { grid-area: 3 / 4 / 4 / 5; }
        .div9 { grid-area: 4 / 4 / 5 / 5; }
        .div10 { grid-area: 5 / 3 / 6 / 4; }
        .div11 { grid-area: 1 / 2 / 5 / 4; }
        </style>



// WEBPACK FOOTER //
// src/components/selectChara.vue